<template>
	<div>
		<el-card>
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="用户ID" prop="title">
					<el-input v-model="form.uids" placeholder="请输入用户ID,多个用','隔开,默认推送全部用户"></el-input>
				</el-form-item>
				<el-form-item label="文章链接" prop="title">
					<el-input v-model="form.content" placeholder="请输入文章链接"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">开始推送</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					title: '',
					uids: '',
					content: ''
				},
				btnLoading: false,
				btnDisabled: false
			}
		},
		methods: {
			onSubmit() {
				this.btnLoading = true;
				this.btnDisabled = true;

				if (!this.form.title) {
					this.btnLoading = false;
					this.btnDisabled = false;
					this.$message.error("标题不能为空");
					return
				}
				
				if (!this.form.content) {
					this.btnLoading = false;
					this.btnDisabled = false;
					this.$message.error("文章链接不能为空");
					return
				}
				
				this.$H.post("message/sendArticle", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.form.content = "";
						this.$message.success(res.msg)
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 145px;
		height: 145px;
		line-height: 145px;
		text-align: center;
	}

	.avatar {
		width: 145px;
		height: 145px;
		display: block;
	}
</style>
